export default {
      id: "polygon-usage",
      viewBox: "0 0 8 7",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#polygon-usage",
      toString: function () {
        return this.url;
      }
    }